<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-4">
      <v-btn border color="white" @click="cancel">
        <v-icon icon="mdi-chevron-left"></v-icon>
        <span class="font-weight-medium"> Назад до реєстру</span>
      </v-btn>

      <div class="d-flex align-center ga-3">
        <v-btn border color="white" @click="cancel">
          <span class="font-weight-medium">Скасувати</span>
        </v-btn>
        <v-btn
          :loading="$loading.isLoading('createIncident')"
          color="grey-darken-4"
          @click="createIncident">
          <v-icon class="mr-1">mdi-check</v-icon>
          <span class="font-weight-medium"> Створити інцидент</span>
        </v-btn>
      </div>
    </div>

    <v-card class="mb-4">
      <v-card-text>
        <div class="d-flex align-center ga-4">
          <v-avatar
            class="bg-red-lighten-5 text-red-darken-2"
            rounded="lg"
            size="56">
            <v-icon icon="mdi-alert-outline" size="26"></v-icon>
          </v-avatar>
          <div>
            <div class="d-flex align-center ga-3 mb-1">
              <span class="font-size-16 font-weight-bold">Новий інцидент</span>
              <v-chip
                class="font-weight-bold text-uppercase"
                color="primary"
                size="small"
                variant="tonal">
                {{ draftStatus.name }}
              </v-chip>
            </div>
            <div class="font-size-13 text-medium-emphasis">
              Зареєструйте подію операційного ризику.
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <b-input
              v-model="credentials.name"
              :error-messages="getErrorMessages(v$.name)"
              hide-details
              label="Назва"
              placeholder="Наприклад: Відмова серверу CRM на 4 години"
              @blur="v$.name.$touch()"></b-input>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <b-select
              v-model="credentials.typeId"
              :error-messages="getErrorMessages(v$.typeId)"
              :items="$directory.get('incidentTypes')"
              :loading="$loading.isLoading('incidentTypes')"
              hide-details
              label="Тип інциденту"
              placeholder="- Оберіть тип -"
              @blur="v$.typeId.$touch()"
              @focus="$directory.fill('incidentTypes')"></b-select>
          </v-col>
          <v-col cols="12" md="6">
            <b-select
              v-model="credentials.categoryId"
              :error-messages="getErrorMessages(v$.categoryId)"
              :items="$directory.get('incidentCategories')"
              :loading="$loading.isLoading('incidentCategories')"
              hide-details
              label="Категорія"
              placeholder="- Оберіть категорію -"
              @blur="v$.categoryId.$touch()"
              @focus="$directory.fill('incidentCategories')"></b-select>
          </v-col>
          <v-col cols="12" md="6">
            <b-select
              v-model="credentials.priorityId"
              :error-messages="getErrorMessages(v$.priorityId)"
              :items="$directory.get('incidentPriorities')"
              :loading="$loading.isLoading('incidentPriorities')"
              hide-details
              label="Пріоритет"
              @blur="v$.priorityId.$touch()"
              @focus="$directory.fill('incidentPriorities')">
              <template #selection="{ item }">
                <div class="d-flex align-center ga-2">
                  <v-icon
                    :color="getIncidentPriorityColor(item.raw.id)"
                    size="x-small">
                    mdi-circle
                  </v-icon>
                  <span>{{ item.raw.name }}</span>
                </div>
              </template>
              <template #item="{ item, props }">
                <v-list-item v-bind="props">
                  <template #prepend>
                    <v-icon
                      :color="getIncidentPriorityColor(item.raw.id)"
                      size="x-small">
                      mdi-circle
                    </v-icon>
                  </template>
                </v-list-item>
              </template>
            </b-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <b-input-date
              v-model="credentials.occurredDate"
              hide-details
              label="Дата виникнення"></b-input-date>
          </v-col>
          <v-col cols="12" md="6">
            <b-input-date
              v-model="credentials.detectedDate"
              hide-details
              label="Дата виявлення"></b-input-date>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts" setup>
import { BInput, BInputDate, BSelect } from 'best-modules/components'
import { getErrorMessages } from 'best-modules/utils'
import { initIncidentCreate } from './IncidentCreate'
import { getIncidentPriorityColor } from '../constants'

defineOptions({
  name: 'IncidentCreate',
})

const { cancel, createIncident, credentials, draftStatus, v$ } =
  initIncidentCreate()
</script>
